// extracted by mini-css-extract-plugin
export default {"bookingInfoWrapper":"BookingInfoMaybe_bookingInfoWrapper__ThzQG marketplaceTinyFontStyles","itemPrice":"BookingInfoMaybe_itemPrice__NMSGI"};